import {
  createFrontendPlugin,
  PageBlueprint,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RadixIcon } from './components/RadixIcon/RadixIcon';
import { rootRouteRef } from './routes';

export const radixAppsPage = PageBlueprint.make({
  params: {
    path: '/radix-apps',
    routeRef: rootRouteRef,
    loader: () => import('./components/RadixAppsPage/RadixAppsPage').then(m => <m.RadixAppsPage />),
  },
});

export const radixPlugin = createFrontendPlugin({
  pluginId: 'radix',
  title: 'Radix',
  icon: <RadixIcon />,
  extensions: [radixAppsPage],
  routes: {
    root: rootRouteRef,
  },
});

const categorySubPage = (category: 'production' | 'playground', title: string) =>
  SubPageBlueprint.make({
    name: category,
    attachTo: { id: 'page:radix', input: 'pages' },
    params: {
      path: category,
      title,
      loader: () =>
        import('./components/RadixAppsPage/RadixAppsPage').then(m => (
          <m.RadixCategoryApps category={category} />
        )),
    },
  });

// Used when `new-frontend-system` is on. Without a loader, the page renders its sub-pages as native header tabs.
export const nfsRadixPlugin = radixPlugin.withOverrides({
  extensions: [
    radixPlugin.getExtension('page:radix').override({ params: { loader: undefined } }),
    // The first sub-page is the default tab.
    categorySubPage('playground', 'Playground apps'),
    categorySubPage('production', 'Production apps'),
  ],
});
